import './TableGrid.css';

interface EditModeToggleProps {
  active: boolean;
  onClick: () => void;
}

export function EditModeToggle({ active, onClick }: EditModeToggleProps) {
  return (
    <button
      type="button"
      className={`sky-edit-mode-toggle ${active ? 'active' : ''}`}
      onClick={onClick}
      title={active ? 'Exit edit mode' : 'Enter edit mode'}
    >
      <svg
        width={14}
        height={14}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
      {active ? 'Editing' : 'Edit'}
    </button>
  );
}

interface UndoLastEditButtonProps {
  /** False when the grid has no inline edit left to reverse. */
  canUndo: boolean;
  /** Label of the edit the button reverses next, for the tooltip. */
  nextUndoLabel?: string | null;
  onClick: () => void;
}

/**
 * Sits next to the Edit toggle (REG-739): reverses the grid's most recent
 * inline edit by writing the previous value back through the same path.
 */
export function UndoLastEditButton({ canUndo, nextUndoLabel, onClick }: UndoLastEditButtonProps) {
  return (
    <button
      type="button"
      className="sky-edit-mode-toggle sky-undo-edit"
      disabled={!canUndo}
      onClick={onClick}
      aria-label="Undo last edit"
      title={canUndo && nextUndoLabel ? `Undo the last edit (${nextUndoLabel})` : 'Nothing to undo'}
    >
      <svg
        width={14}
        height={14}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 7v6h6" />
        <path d="M21 17a9 9 0 0 0-15-6.7L3 13" />
      </svg>
      Undo
    </button>
  );
}
